import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import RoomOffer from './RoomOffer';
import { getRoomOfferByRoomTypeId, getNoOfSelectedRooms } from '../../apiHelpers';
import T from '../Translate';


class SelectedRooms extends Component {

	render() {
		const { formValues, roomOffers } = this.props;

		return (
			<div>
				<fieldset className="fieldset">
					<legend><T id="SelectedRooms.index.title" data={{ count: getNoOfSelectedRooms(formValues) }} /></legend>
				</fieldset>

				<div className="rooms">
					<div className="room-offers">
						{/* Projdeme vybrané typy pokojů */}
						{Object.entries(formValues.rooms).map(([roomTypeId, rooms], roomTypeIndex) => {
							// A pro každý typ pokoje počet konkrétních pokojů
							return rooms.map((room, roomIndex) => (
								<RoomOffer
									key={`${roomTypeId}-${roomIndex}`}
									roomOffer={getRoomOfferByRoomTypeId(roomTypeId, roomOffers)}
									roomIndex={roomIndex}
									isLast={
										Object.keys(formValues.rooms).length - 1 === roomTypeIndex &&
										formValues.rooms[roomTypeId].length - 1 === roomIndex
									}
								/>
							));
						})}
					</div>
				</div>
			</div>
		);
	}
}


export default compose(
	connect(state => ({
		formValues: getFormValues('bookingForm')(state),
		roomOffers: state.app.roomOffers,
	})),
)(SelectedRooms)


// WEBPACK FOOTER //
// ./src/components/SelectedRooms/index.jsx